import { FilterAltTwoTone } from '@mui/icons-material'
import React from 'react'
import CustomIconButton from './CustomIconButton'

const FilterButton = ({ onClick }) => {
  return (
    <div>
      <CustomIconButton
            disableRipple title="Filters" variant='secondary' onClick={onClick}>
        <FilterAltTwoTone sx={{ color: '#6c757d' }} color="#6c757d" />
      </CustomIconButton>
    </div>
  )
}

export default FilterButton
